const headRowsVerification = {
  actions: 'Actions',
  name: 'Group',
  alert: 'Generate action'
};

export default headRowsVerification;
